/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Footer_ExploreInputs */

const en_footer_explore = /** @type {(inputs: Footer_ExploreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Explore`)
};

const es_footer_explore = /** @type {(inputs: Footer_ExploreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Explorar`)
};

const de_footer_explore = /** @type {(inputs: Footer_ExploreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erkunden`)
};

const zh_footer_explore = /** @type {(inputs: Footer_ExploreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`探索`)
};

const ar_footer_explore = /** @type {(inputs: Footer_ExploreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`استكشف`)
};

const fr_footer_explore = /** @type {(inputs: Footer_ExploreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Explorer`)
};

const vi_footer_explore = /** @type {(inputs: Footer_ExploreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Khám phá`)
};

const sw_footer_explore = /** @type {(inputs: Footer_ExploreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chunguza`)
};

const th_footer_explore = /** @type {(inputs: Footer_ExploreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`สำรวจ`)
};

const bs_footer_explore = /** @type {(inputs: Footer_ExploreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Istraži`)
};

const ja_footer_explore = /** @type {(inputs: Footer_ExploreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`メニュー`)
};

const ko_footer_explore = /** @type {(inputs: Footer_ExploreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`둘러보기`)
};

const pt_footer_explore = /** @type {(inputs: Footer_ExploreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Explorar`)
};

const it_footer_explore = /** @type {(inputs: Footer_ExploreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esplora`)
};

const sv_footer_explore = /** @type {(inputs: Footer_ExploreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Utforska`)
};

const nl_footer_explore = /** @type {(inputs: Footer_ExploreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verkennen`)
};

const da_footer_explore = /** @type {(inputs: Footer_ExploreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Udforsk`)
};

const nb_footer_explore = /** @type {(inputs: Footer_ExploreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Utforsk`)
};

const fi_footer_explore = /** @type {(inputs: Footer_ExploreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tutki`)
};

const pl_footer_explore = /** @type {(inputs: Footer_ExploreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Poznaj`)
};

const ru_footer_explore = /** @type {(inputs: Footer_ExploreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Разделы`)
};

const tr_footer_explore = /** @type {(inputs: Footer_ExploreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keşfet`)
};

const hi_footer_explore = /** @type {(inputs: Footer_ExploreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`अन्वेषण`)
};

const id_footer_explore = /** @type {(inputs: Footer_ExploreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jelajahi`)
};

const ms_footer_explore = /** @type {(inputs: Footer_ExploreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Terokai`)
};

const cs_footer_explore = /** @type {(inputs: Footer_ExploreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prozkoumejte`)
};

const el_footer_explore = /** @type {(inputs: Footer_ExploreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Εξερευνήστε`)
};

const he_footer_explore = /** @type {(inputs: Footer_ExploreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`גלו`)
};

const af_footer_explore = /** @type {(inputs: Footer_ExploreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verken`)
};

const hu_footer_explore = /** @type {(inputs: Footer_ExploreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fedezd fel`)
};

/**
* | output |
* | --- |
* | "Explore" |
*
* @param {Footer_ExploreInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const footer_explore = /** @type {((inputs?: Footer_ExploreInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Footer_ExploreInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_footer_explore(inputs)
	if (locale === "de") return de_footer_explore(inputs)
	if (locale === "zh") return zh_footer_explore(inputs)
	if (locale === "ar") return ar_footer_explore(inputs)
	if (locale === "fr") return fr_footer_explore(inputs)
	if (locale === "vi") return vi_footer_explore(inputs)
	if (locale === "sw") return sw_footer_explore(inputs)
	if (locale === "th") return th_footer_explore(inputs)
	if (locale === "bs") return bs_footer_explore(inputs)
	if (locale === "ja") return ja_footer_explore(inputs)
	if (locale === "ko") return ko_footer_explore(inputs)
	if (locale === "pt") return pt_footer_explore(inputs)
	if (locale === "it") return it_footer_explore(inputs)
	if (locale === "sv") return sv_footer_explore(inputs)
	if (locale === "nl") return nl_footer_explore(inputs)
	if (locale === "da") return da_footer_explore(inputs)
	if (locale === "nb") return nb_footer_explore(inputs)
	if (locale === "fi") return fi_footer_explore(inputs)
	if (locale === "pl") return pl_footer_explore(inputs)
	if (locale === "ru") return ru_footer_explore(inputs)
	if (locale === "tr") return tr_footer_explore(inputs)
	if (locale === "hi") return hi_footer_explore(inputs)
	if (locale === "id") return id_footer_explore(inputs)
	if (locale === "ms") return ms_footer_explore(inputs)
	if (locale === "cs") return cs_footer_explore(inputs)
	if (locale === "el") return el_footer_explore(inputs)
	if (locale === "he") return he_footer_explore(inputs)
	if (locale === "af") return af_footer_explore(inputs)
	if (locale === "hu") return hu_footer_explore(inputs)
	return en_footer_explore(inputs)
});